<mat-sidenav-container class="app-container">
  <mat-sidenav #sidenav mode="side" opened class="app-sidenav app-sidenav-light" [fixedInViewport]="options.fixed"
    [fixedTopGap]="options.topGap" [fixedBottomGap]="options.bottomGap" [(opened)]="options.defaultOpen"
    *ngIf="loggedUser">
    <mat-nav-list>
      <ng-container *ngFor="let item of navItems; let t = index">
        <a mat-list-item
          *ngIf="!item.items && item.route === '' && hasAtLeastOnePermisson(item) && hasCorrectRole(item)"
          routerLink="/{{ lang + item.route }}" [ngClass]="{'active': isRouteActive(item.route)}"
          (click)="onCurrentOpened(t)">
          <mat-icon aria-hidden="false" *ngIf="item.icon" fontSet="fal" fontIcon="{{ item.icon }}"></mat-icon>
          {{ item.translate | translate }}
        </a>
        <a mat-list-item
          *ngIf="!item.items && item.route && item.route !== '' && hasAtLeastOnePermisson(item) && hasCorrectRole(item)"
          routerLink="/{{ lang + item.route }}" [ngClass]="{'active': isRouteActive(item.route)}"
          (click)="onCurrentOpened(t)">
          <mat-icon aria-hidden="false" *ngIf="item.icon" fontSet="fal" fontIcon="{{ item.icon }}"></mat-icon>
          <!-- admin items -->
          <ng-container *ngIf="roleType && (roleType === 'admin' || roleType === 'operator')">
            <!-- items different from "Home" without notification -->
            <span *ngIf="!(tankDocumentsCount || lastInsertedDocs) && item.translate !== 'sidenav.dashboard'">
              {{ item.translate | translate }}
            </span>
            <!-- items different from "Home" with notification -->
            <span *ngIf="(tankDocumentsCount || lastInsertedDocs) && item.translate !== 'sidenav.dashboard'">
              {{ item.translate | translate }}
            </span>
            <!-- "Home" item without notification -->
            <span *ngIf="!(tankDocumentsCount || lastInsertedDocs) && item.translate === 'sidenav.dashboard'">
              {{ item.translate | translate }}
            </span>
            <!-- "Home" item with notification -->
            <span class="notification-badge" matBadge="!" matBadgeOverlap="false"
              matTooltip="Hai delle notifiche in attesa"
              *ngIf="(tankDocumentsCount || lastInsertedDocs) && item.translate === 'sidenav.dashboard'">
              {{ item.translate | translate }}
            </span>
          </ng-container>
          <ng-container *ngIf="roleType && (roleType === 'master' || roleType === 'collaborator' || roleType === 'temporary')">
            <!-- items different from "Home" without notification -->
            <span *ngIf="!lastInsertedDocs && item.translate !== 'sidenav.dashboard'">
              {{ item.translate | translate }}
            </span>
            <!-- items different from "Home" with notification -->
            <span *ngIf="lastInsertedDocs && item.translate !== 'sidenav.dashboard'">
              {{ item.translate | translate }}
            </span>
            <!-- "Home" item without notification -->
            <span *ngIf="!lastInsertedDocs && item.translate === 'sidenav.dashboard'">
              {{ item.translate | translate }}
            </span>
            <!-- "Home" item with notification -->
            <span class="notification-badge" matBadge="!" matBadgeOverlap="false"
              matTooltip="Hai delle notifiche in attesa"
              *ngIf="lastInsertedDocs && item.translate === 'sidenav.dashboard'">
              {{ item.translate | translate }}
            </span>
          </ng-container>
          <!-- other roles items -->
          <ng-container *ngIf="roleType && roleType === 'shared'">
            {{ item.translate | translate }}
          </ng-container>
        </a>
        <div *ngIf="!item.items && !item.route && hasAtLeastOnePermisson(item) && hasCorrectRole(item)" class="divider">
          <mat-icon aria-hidden="false" *ngIf="item.icon" fontSet="fal" fontIcon="{{ item.icon }}"></mat-icon>
          {{ item.translate | translate }}
        </div>
        <mat-accordion *ngIf="item.items && hasAtLeastOnePermisson(item) && hasCorrectRole(item)">
          <!-- activeRoute.includes(item.route) -->
          <mat-expansion-panel class="mat-elevation-z0" [expanded]="currentOpened===t || isRouteActive(item.route)" (closed)="false" (opened)="onCurrentOpened(t)">
            <!-- ('/' + lang + item.route) === (activeRoute) -->
            <mat-expansion-panel-header [collapsedHeight]="'50px'" [expandedHeight]="'50px'">
              <mat-panel-title>
                <mat-icon aria-hidden="false" *ngIf="item.icon" fontSet="fal" fontIcon="{{ item.icon }}"></mat-icon>
                {{ item.translate | translate }}
                <!-- Arturo's open proposals, also on the closed group -->
                <span class="menu-count" *ngIf="item.name === 'Arturo' && arturoQueueCount > 0">{{ arturoQueueCount }}</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-nav-list>
              <ng-container *ngFor="let subItem of item.items; let y = index">
                <a mat-list-item routerLink="/{{ lang + subItem.route }}" [routerLinkActive]="'active'"
                  *ngIf="!subItem.hasCallbackFn && hasAtLeastOnePermisson(subItem) && hasCorrectRole(subItem) && subItem.route"
                  style="height: 60px;">
                  <mat-icon *ngIf="subItem.icon" aria-hidden="false" fontSet="fal" fontIcon="{{ subItem.icon }}" class="mat-icon-second-level">
                  </mat-icon>
                  {{ subItem.translate | translate }}
                  <span class="menu-count" *ngIf="subItem.name === 'ArturoQueue' && arturoQueueCount > 0">{{ arturoQueueCount }}</span>
                </a>
                <button class="sidenav-button" mat-list-item [routerLinkActive]="'active'"
                  (click)="onAddCommunication()"
                  *ngIf="subItem.hasCallbackFn && hasAtLeastOnePermisson(subItem) && hasCorrectRole(subItem)">
                  <mat-icon *ngIf="subItem.icon" aria-hidden="false" fontSet="fal" fontIcon="{{ subItem.icon }}" class="mat-icon-second-level">
                  </mat-icon>
                  {{ subItem.translate | translate }}
                </button>

                <!-- third level-->
                <mat-expansion-panel class="mat-elevation-z0" [expanded]="subCurrentOpened===y" (closed)="false" (opened)="onSubCurrentOpened(y)" *ngIf="!subItem.route && subItem.items && subItem.items.length && hasCorrectRole(subItem)">
                  <!-- ('/' + lang + subItem.route) === (activeRoute) -->
                  <mat-expansion-panel-header [collapsedHeight]="'50px'" [expandedHeight]="'50px'" style="padding-left: 36px;">
                    <mat-panel-title>
                      <mat-icon aria-hidden="false" *ngIf="subItem.icon" fontSet="fal" fontIcon="{{ subItem.icon }}" class="mat-icon-second-level"></mat-icon>
                      {{ subItem.translate | translate }}
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <mat-nav-list>
                    <ng-container *ngFor="let subSubItem of subItem.items">
                      <a mat-list-item routerLink="/{{ lang + subSubItem.route }}" [routerLinkActive]="'active'"
                        *ngIf="!subSubItem.hasCallbackFn && hasAtLeastOnePermisson(subSubItem) && hasCorrectRole(subSubItem) && subSubItem.route"
                        style="padding-left: 40px;">
                        <mat-icon *ngIf="subSubItem.icon" aria-hidden="false" fontSet="fal" fontIcon="{{ subSubItem.icon }}" class="mat-icon-second-level">
                        </mat-icon>
                        {{ subSubItem.translate | translate }}
                      </a>
                    </ng-container>
                  </mat-nav-list>
                </mat-expansion-panel>
                <!-- third level-->

              </ng-container>
            </mat-nav-list>
          </mat-expansion-panel>
        </mat-accordion>
      </ng-container>
    </mat-nav-list>

  </mat-sidenav>

  <mat-sidenav-content>
    <router-outlet class="content-wrapper"></router-outlet>
    <app-footer></app-footer>
  </mat-sidenav-content>
</mat-sidenav-container>